module.exports = __webpack_public_path__ + "static/media/1021405.579db767.jpg";